import { makeAutoObservable } from 'mobx';
import { ReportBI } from '../services';
import { ConditionalModalState } from './ConditionalModalState';
import { DataExtensionStateBIReporter } from './DataExtensionStateBIReporter';
import { DataExtensionState } from './DataExtensionState';

export interface DeleteFieldModalStateParams {
  dataExtension: DataExtensionState;
  readonly reportBi: ReportBI;
}

export class DeleteFieldModalState {
  readonly biReporter;
  readonly dataExtension;
  readonly modal;

  constructor(params: DeleteFieldModalStateParams) {
    this.biReporter = new DataExtensionStateBIReporter({
      reportBi: params.reportBi,
    });
    this.modal = new ConditionalModalState<{
      id: string;
      origin: string;
    }>({
      onConfirm: async () => {
        if (!this.modal.value) {
          return;
        }

        this.biReporter.reportDeleteFieldModalCtaClicked('Delete');
        await this.dataExtension.deleteField({
          ...this.modal.value,
          reportBi: this.biReporter.reportBi,
        });

        // Close archived panel if no items left
        const remainingItems = this.dataExtension.archivedItems;
        if (remainingItems.length === 0) {
          this.dataExtension.closeArchivedPanel();
        }
      },
      onClose: () => {
        this.biReporter.reportDeleteFieldModalCtaClicked('Cancel');
      },
    });
    this.dataExtension = params.dataExtension;
    makeAutoObservable(this);
  }
}

